import {
  BoxBufferGeometry,
  Color,
  Mesh,
  MeshBasicMaterial,
  Object3D,
  PerspectiveCamera,
  Vector3,
} from "three";
import GPUParticles from "./GPUParticles/GPUParticles";

const TMP_COL = new Color(0x33eb40);
const TMP_1 = new Vector3();

interface Options {
  spawnRate: number;
  activeDistance: number;
  radius: number;
  colour: Color;
  spread: number;
  velocityRandomness: number;
  getLifespan: () => number;
  getSpeed: () => number;
}

class RingEmitterParticles extends Object3D {
  private particleSystem: GPUParticles;
  private camera: PerspectiveCamera;
  private spawnRate: number;
  private activeDistance: number;
  private radius: number;
  private colour: Color;
  private spread: number;
  private velocityRandomness: number;
  private getLifespan: () => number;
  private getSpeed: () => number;

  constructor(
    particleSystem: GPUParticles,
    camera: PerspectiveCamera,
    {
      spawnRate,
      activeDistance,
      radius,
      colour,
      getLifespan,
      getSpeed,
      spread,
      velocityRandomness,
    }: Options
  ) {
    super();
    this.particleSystem = particleSystem;
    this.camera = camera;

    this.spawnRate = spawnRate;
    this.activeDistance = activeDistance;
    this.radius = radius;
    this.colour = colour;
    this.spread = spread;
    this.velocityRandomness = velocityRandomness;
    this.getLifespan = getLifespan;
    this.getSpeed = getSpeed;

    // this.add(
    //   new Mesh(
    //     new BoxBufferGeometry(1, 1, 1),
    //     new MeshBasicMaterial({ color: 0xff00ff })
    //   )
    // );
  }

  public update(delta: number): void {
    if (this.camera.position.distanceTo(this.position) <= this.activeDistance) {
      const spawnCount = (this.spawnRate / 60) * delta;
      for (let i = 0; i < spawnCount; i++) {
        const theta = Math.PI * 2 * Math.random();

        this.particleSystem.spawnParticle({
          position: TMP_1.set(
            Math.cos(theta) * this.radius,
            0,
            Math.sin(theta) * this.radius
          ).add(this.position),
          spread: this.spread,
          velocityRandomness: this.velocityRandomness,
          velocity: new Vector3(0, 1, 0),
          lifespan: this.getLifespan(),
          color: this.colour,
          speed: this.getSpeed(),
        });
      }
    }
  }
}

export default RingEmitterParticles;
